export interface HearingNoticeComment {
  id: number;
  hearingNoticeId: number;
  nameOfPersonCommenting: string;
  affiliationOfPersonCommenting: string;
  comment: string;
  agencyResponse: string;
  createdBy?: string;
  createdOn?: Date;
}

export const CreateEmptyHearingNoticeComment = () => {
  let emptyHearingNoticeComment: HearingNoticeComment = {
    id: -1,
    hearingNoticeId: -1,
    nameOfPersonCommenting: "",
    affiliationOfPersonCommenting: "",
    comment: "",
    agencyResponse: "",
  };
  return emptyHearingNoticeComment;
}